<script setup lang="ts">
import { DataSourceLookup } from '@/components';
import type { SelectLineValueType } from '@/objects';
import { BibAssignSort } from '@/objects/generated';
import { EventDao, SeriesDao, SeedingListDao } from '@/dao';

let props = defineProps<{ value: number | null; row: BibAssignSort }>();

const resultLookup = async (a: SelectLineValueType) => {
    if (a == null) {
        return 'general.none';
    }
    const result = await EventDao.EventAsSelectLine(a as number);
    return result?.text || 'general.none';
};

const seriesLookup = async (a: SelectLineValueType) => {
    if (a == null) {
        return 'general.none';
    }
    const result = await SeriesDao.SeriesAsSelectLine(a as number);
    return result?.text || 'general.none';
};

const seedingListLookup = async (a: SelectLineValueType) => {
    if (a == null) {
        return 'general.none';
    }
    const result = await SeedingListDao.SeedingListAsSelectLine(a as number);
    return result?.text || 'general.none';
};
</script>
<template>
    <div>
        <span v-if="value">({{ value }}) </span>
        <DataSourceLookup
            v-if="props.row?.SortType == 'Result'"
            :value="props.value"
            :datasource="{ asyncsource: resultLookup }"
            :hideCaret="true"
        ></DataSourceLookup>
        <DataSourceLookup
            v-if="props.row?.SortType == 'Series'"
            :value="props.value"
            :datasource="{ asyncsource: seriesLookup }"
            :hideCaret="true"
        ></DataSourceLookup>
        <DataSourceLookup
            v-if="props.row?.SortType == 'SeedingList'"
            :value="props.value"
            :datasource="{ asyncsource: seedingListLookup }"
            :hideCaret="true"
        ></DataSourceLookup>
    </div>
</template>
